import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {Button, Card, CardBody, IconButton, Typography} from "@material-tailwind/react";
import dayjs from 'dayjs';
import Footer from "./footer";
import {Car, CheckCircle} from "lucide-react";
import SummaryPanel from "./SummaryPanel";
import MobileNextButton from "./MobileNextButton";

function CarInfo() {
    //const nextUrl = "/contact";
    const navigate = useNavigate();
    const rightProps = {nextUrl: "/contact", ready: false};
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedMakes, setSelectedMakes] = useState("");
    const [selectedModels, setSelectedModels] = useState("");
    const [selectedYears, setSelectedYears] = useState("");
    const [selectedPlate, setSelectedPlate] = useState("");
    const [selectedMileage, setSelectedMileage] = useState("");
    const [selectedVIN, setSelectedVIN] = useState("");
    const [serviceList, setServiceList] = useState(null);
    const [carList, setCarList] = useState([]);
    const [selectedCar, setSelectedCar] = useState("");
    const [addCar, setAddCar] = useState(false);
    const [makeList, setMakeList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [branch, setBranch] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const makesHandler = (event) => {
        setSelectedMakes(event.target.value);
        getOEMs(1, event.target.value);
        let carDesc = '';
        for (let i = 0; i < makeList.length; i++) {
            if (makeList[i].id === event.target.value) {
                carDesc = makeList[i].description;
            }
        }

        localStorage.setItem("make", carDesc);
        localStorage.setItem("makeID", event.target.value);
    };

    const yearsHandler = (event) => {
        setSelectedYears(event.target.value);
        localStorage.setItem("year", event.target.value);
    };

    const modelHandler = (event) => {
        setSelectedModels(event.target.value);

        let carDesc = '';
        for (let i = 0; i < modelList.length; i++) {
            if (modelList[i].id === event.target.value) {
                carDesc = modelList[i].description;
            }
        }

        localStorage.setItem("model", carDesc);
        localStorage.setItem("modelID", event.target.value);
    };

    const plateHandler = (event) => {
        setSelectedPlate(event.target.value);
        localStorage.setItem("plate", event.target.value);
    };

    const mileageHandler = (event) => {
        setSelectedMileage(event.target.value);
        localStorage.setItem("mileage", event.target.value);
    };

    const vinHandler = (event) => {
        setSelectedVIN(event.target.value);
        localStorage.setItem("vin", event.target.value);
    };

    const getCarList = async () => {
        //암호화된 car_id 로컬에서 먼저 삭제. 다른 차들이랑 충돌 날 수 있음.
        localStorage.setItem('eid', '');

        setServiceList(JSON.parse(localStorage.getItem("services")));
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getCarList", {
                    withCredentials: true,
                })
                .then((response) => {
                    setCarList(response.data);
                })
                .catch((error) => {
                    navigate("/");
                    console.log(error);
                });
        } catch (e) {
            console.log(e);
        }
    };

    const getAddress = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getAddress", {
                    withCredentials: true,
                })
                .then((response) => {
                    setBranch(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/");
                });
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        getCarList();
        getOEMs(0, null);
        getYears();
        getAddress();
    }, []);


    const carHandler = (event) => {
        setSelectedCar(event.target.value);
        for (let i = 0; i < carList.length; i++) {
            if (carList[i].eid == event.target.value) {
                localStorage.setItem("eid", carList[i].eid);

                setSelectedPlate(carList[i].plate);
                localStorage.setItem("plate", carList[i].plate);

                setSelectedMileage(carList[i].mileage);
                localStorage.setItem("mileage", carList[i].mileage);

                setSelectedVIN(carList[i].vin);
                localStorage.setItem("vin", carList[i].vin);

                setSelectedMakes(carList[i].make);
                localStorage.setItem("make", carList[i].make);
                localStorage.setItem("makeID", carList[i].makeID);

                setSelectedYears(carList[i].year);
                localStorage.setItem("year", carList[i].year);

                setSelectedModels(carList[i].model);
                localStorage.setItem("model", carList[i].model);
                localStorage.setItem("modelID", carList[i].modelID);
            }
        }
    };

    const newCarHandler = () => {
        //자동차를 새로 생성 여부에 따라 Select a model , select a car 보여줄지 결정.

        localStorage.setItem("eid", '');

        setSelectedPlate('');
        localStorage.setItem("plate", '');

        setSelectedMileage('');
        localStorage.setItem("mileage", '');

        setSelectedVIN('');
        localStorage.setItem("vin", '');

        setSelectedMakes('');
        localStorage.setItem("make", '');

        setSelectedYears('');
        localStorage.setItem("year", '');

        setSelectedModels('');
        localStorage.setItem("model", '');

        if (!addCar) {
            setSelectedCar('');
        }
        setAddCar(!addCar);
    }

    const getOEMs = async (level, parentID) => {
        const params = {
            'level': level,
            'parentID': parentID,
        };
        try {
            await axios.get(process.env.REACT_APP_API_URL + "/api/v1/getOEMs", {params: params, withCredentials: true})
                .then(response => {

                    if (level == 0) {
                        setMakeList(response.data);
                    } else {
                        setModelList(response.data);
                    }

                }).catch(error => {
                    console.log(error);
                })
        } catch (e) {
            console.log(e);
        }
    };

    const getYears = () => {
        const years = [];
        for (let i = 1980; i < dayjs().add(5, 'year').year(); i++) {
            years.push(i);
        }

        setYearList(years);
    }

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-50">
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6">
                    {/* Enhanced Header with back button */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                            <IconButton
                                variant="outlined"
                                color="blue-gray"
                                size="lg"
                                onClick={() => navigate("/schedule")}
                                className="border-gray-300 hover:bg-gray-50 transition-all duration-300"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={2}
                                    stroke="currentColor"
                                    className="w-5 h-5 sm:w-6 sm:h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </IconButton>
                            <div>
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl">
                                    Car Information
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base">
                                    Tell us about your vehicle
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-between w-full max-w-4xl">
                                {/* Step 1 - Select Services */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/services")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            1. Services
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 2 - Choose Schedule */}
                                <div className="flex items-center justify-center">
                                    <div className="flex items-center cursor-pointer" onClick={() => navigate("/schedule")}>
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-green-500 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0 cursor-pointer hover:bg-green-600 transition-colors duration-300"
                                        >
                                            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        {/* Text label - hidden on mobile */}
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-green-600 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            2. Schedule
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 2 */}
                                <div className="flex-1 h-0.5 bg-blue-500 mx-2 sm:mx-4"></div>

                                {/* Step 3 - Car Information (CURRENT) */}
                                <div className="flex items-center justify-center relative">
                                    <div className="relative">
                                        {/* Pulsing ring animation - hidden on mobile */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-blue-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-blue-500 to-blue-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            3
                                        </div>
                                    </div>

                                    {/* Current step indicator - hidden on mobile */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-blue-600 text-sm sm:text-base whitespace-nowrap">
                                            Car
                                        </Typography>
                                        <div className="text-xs text-blue-500 font-medium">
                                            Current Step
                                        </div>
                                    </div>
                                </div>

                                {/* Connector line 3 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 4 - Contact Information */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        4
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Contact
                                    </Typography>
                                </div>

                                {/* Connector line 4 */}
                                <div className="flex-1 h-0.5 bg-gray-300 mx-2 sm:mx-4"></div>

                                {/* Step 5 - Complete */}
                                <div className="flex items-center justify-center">
                                    <div
                                        className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0">
                                        5
                                    </div>
                                    {/* Text label - hidden on mobile */}
                                    <Typography variant="small"
                                                className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block">
                                        Complete
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 justify-center">
                        {/* Enhanced Car Information Section */}
                        <div className="flex-1 max-w-5xl">
                            <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
                                <CardBody className="p-4 sm:p-6 lg:p-8">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
                                        {/* Car Information Form */}
                                        <div className="lg:col-span-2">
                                            <div className="mb-6 sm:mb-8">
                                                <div className="flex items-center gap-2 mb-2">
                                                    <Car className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600"/>
                                                    <Typography variant="h5" color="blue-gray"
                                                                className="font-bold text-lg sm:text-xl lg:text-2xl">
                                                        Vehicle Details
                                                    </Typography>
                                                </div>
                                                {/*<Typography variant="paragraph" color="gray"*/}
                                                {/*            className="mb-4 sm:mb-6 text-sm sm:text-base">*/}
                                                {/*    Please provide your vehicle information for accurate service.*/}
                                                {/*</Typography>*/}
                                            </div>

                                            <div className="space-y-6">
                                                {carList.length > 0 && (
                                                    <>
                                                        {!addCar && (
                                                            <div className="mb-6">
                                                                {/*<Typography variant="h6"*/}
                                                                {/*            className="mb-3 font-semibold text-blue-gray-800">*/}
                                                                {/*    Select from My Cars*/}
                                                                {/*</Typography>*/}
                                                                <select
                                                                    value={selectedCar}
                                                                    onChange={carHandler}
                                                                    className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                >
                                                                    <option value="">Select Car</option>
                                                                    {carList.map((car) => (
                                                                        <option key={car.eid} value={car.eid}>
                                                                            {car.make} {car.model} {car.year}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}

                                                        <div className="mb-6">
                                                            <Button
                                                                variant="text"
                                                                color="blue"
                                                                onClick={newCarHandler}
                                                                className="text-left p-0 font-semibold hover:bg-blue-50 px-2 py-1 rounded-lg transition-all duration-300"
                                                            >
                                                                {!addCar ? "Add a new car" : "Select from my cars"}
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}

                                                {(carList.length == 0 || addCar) && (
                                                    <div className="mb-6">
                                                        <Typography variant="h6"
                                                                    className="mb-4 font-semibold text-blue-gray-800">
                                                            Vehicle Model
                                                        </Typography>

                                                        <div className="space-y-4">
                                                            <div>
                                                                <Typography variant="small"
                                                                            className="mb-2 font-medium text-blue-gray-700">
                                                                    Make
                                                                </Typography>
                                                                <select
                                                                    id="makes"
                                                                    value={selectedMakes}
                                                                    onChange={makesHandler}
                                                                    className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                >
                                                                    <option value="">Select Make</option>
                                                                    {makeList?.map((oem) => (
                                                                        <option key={oem.description} value={oem.id}>
                                                                            {oem.description}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div>
                                                                <Typography variant="small"
                                                                            className="mb-2 font-medium text-blue-gray-700">
                                                                    Model
                                                                </Typography>
                                                                <select
                                                                    id="models"
                                                                    value={selectedModels}
                                                                    onChange={modelHandler}
                                                                    className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                >
                                                                    <option value="">Select Model</option>
                                                                    {modelList?.map((oem) => (
                                                                        <option key={oem.description} value={oem.id}>
                                                                            {oem.description}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div>
                                                                <Typography variant="small"
                                                                            className="mb-2 font-medium text-blue-gray-700">
                                                                    Year
                                                                </Typography>
                                                                <select
                                                                    id="years"
                                                                    value={selectedYears}
                                                                    onChange={yearsHandler}
                                                                    className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                >
                                                                    <option value="">Select Year</option>
                                                                    {yearList?.map((year) => (
                                                                        <option key={year} value={year}>{year}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="pt-6 border-t border-gray-200">
                                                    <Typography variant="h6"
                                                                className="mb-4 font-semibold text-blue-gray-800">
                                                        Additional Information
                                                    </Typography>
                                                    {/*<Typography variant="small" color="gray" className="mb-4">*/}
                                                    {/*    Optional details to help us provide better service*/}
                                                    {/*</Typography>*/}

                                                    <div className="space-y-4">
                                                        <div>
                                                            <Typography variant="small"
                                                                        className="mb-2 font-medium text-blue-gray-900">
                                                                Plate Number
                                                            </Typography>
                                                            <input
                                                                value={selectedPlate}
                                                                maxLength={10}
                                                                onChange={plateHandler}
                                                                className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                type="text"
                                                                placeholder="Enter plate number (optional)"
                                                            />
                                                        </div>

                                                        <div>
                                                            <Typography variant="small"
                                                                        className="mb-2 font-medium text-blue-gray-900">
                                                                Current Mileage
                                                            </Typography>
                                                            <input
                                                                value={selectedMileage}
                                                                maxLength={20}
                                                                onChange={mileageHandler}
                                                                className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                type="number"
                                                                placeholder="Enter current mileage (optional)"
                                                            />
                                                        </div>

                                                        <div>
                                                            <Typography variant="small"
                                                                        className="mb-2 font-medium text-blue-gray-900">
                                                                VIN Number
                                                            </Typography>
                                                            <input
                                                                value={selectedVIN}
                                                                maxLength={17}
                                                                onChange={vinHandler}
                                                                className="w-full p-4 text-gray-900 bg-white border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-300 hover:border-gray-300 shadow-sm hover:shadow-md"
                                                                type="text"
                                                                placeholder="Enter VIN number (optional)"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Mobile Next Button */}
                                                <MobileNextButton
                                                    link="/contact"
                                                    enabled={selectedMakes && selectedModels && selectedYears}
                                                    buttonText="Next Step →"
                                                    disabledText="Please select vehicle details"
                                                />
                                            </div>
                                        </div>

                                        {/* Enhanced Summary Panel */}
                                        <div className="lg:col-span-1 order-first lg:order-last hidden lg:block">
                                            <SummaryPanel
                                                link={"/contact"}
                                                branch={branch}
                                                selectedServiceList={serviceList}
                                                dateList={localStorage.getItem("bookingtime")}
                                                selectedCar={selectedCar}
                                                carList={carList}
                                                enabled={selectedMakes && selectedModels && selectedYears}
                                            />
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        </>
    );
}

export default CarInfo;
